<template>
    <div style="height: 100%;width: 100%;overflow: auto;">
        <van-sticky>
            <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
            <el-form :inline="true" class="pfzk" size="mini" style="background-color: white;">
                <el-form-item label="门店"  style="margin: 5px;">
                    <el-select v-model="storeid" placeholder="门店选择" @change="storeChange">
                    <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="text-align: center;margin-bottom: 0px;margin: 5px;">
                    <el-radio-group v-model="type" @change="monthChange">
                        <el-radio-button :label="1">本月</el-radio-button>
                        <el-radio-button :label="2">上月</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </van-sticky>
        <el-descriptions :column="2" border>
            <el-descriptions-item label="当月总人数">{{beautySumData.custnumber}}</el-descriptions-item>
            <el-descriptions-item label="当月总次数">{{beautySumData.ddnumber}}</el-descriptions-item>
            <el-descriptions-item label="当月总项目数">{{beautySumData.number}}</el-descriptions-item>
            <el-descriptions-item label="到店一次人数">{{one}}</el-descriptions-item>
            <el-descriptions-item label="到店两次人数">{{two}}</el-descriptions-item>
            <el-descriptions-item label="到店三次以上人数">{{three}}</el-descriptions-item>
        </el-descriptions>
        <el-divider>到店一次的人数</el-divider>
        <el-table :data="oneData" show-header style="width: 100%">
            <el-table-column prop="membername" align="center" label="客户姓名"></el-table-column>
            <el-table-column prop="ddnumber" align="center" label="到店次数"></el-table-column>
            <el-table-column prop="number" align="center" label="项目数量"></el-table-column>
        </el-table>
        <el-divider>到店两次的人数</el-divider>
        <el-table :data="twoData" show-header style="width: 100%">
            <el-table-column prop="membername" align="center" label="客户姓名"></el-table-column>
            <el-table-column prop="ddnumber" align="center" label="到店次数"></el-table-column>
            <el-table-column prop="number" align="center" label="项目数量"></el-table-column>
        </el-table>
        <el-divider>到店三次以上的人数</el-divider>
        <el-table :data="threeData" show-header style="width: 100%">
            <el-table-column prop="membername" align="center" label="客户姓名"></el-table-column>
            <el-table-column prop="ddnumber" align="center" label="到店次数"></el-table-column>
            <el-table-column prop="number" align="center" label="项目数量"></el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                type:1,
                storeid:localStorage.getItem("storeid"),
                fromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
                todate:this.$moment().endOf('month').format('YYYY-MM-DD'),
                beautySumData:{},
                one:0,
                two:0,
                three:0,
                oneData:[],
                twoData:[],
                threeData:[],
                brands:[],
            }
        },
        created: function () {
            this.getStoreInfoByStructsOpen();
            this.getBeauty31SumData();
            this.getBeauty31DetalData();
        },
        methods: {
            monthChange(e){
                if(e==1){
                    this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
                    this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
                }
                else if(e==2){
                    let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                    this.fromdate=days+"-01";
                    this.todate=days+"-"+this.$moment(this.fromdate, "YYYY-MM-DD").daysInMonth();
                }
                this.getBeauty31SumData();
                this.getBeauty31DetalData();
            },
            storeChange(val){
                localStorage.setItem("storeid",val);
                this.storeid=val;
                this.getBeauty31SumData();
                this.getBeauty31DetalData();
            },
            getStoreInfoByStructsOpen(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.brands=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            getBeauty31DetalData(){
                this.$post("beautymanager/getBeauty31DetalData",{storeid:this.storeid,fromdate:this.fromdate,todate:this.todate}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        this.one=obj.one;
                        this.two=obj.two;
                        this.three=obj.three;
                        this.oneData=obj.oneData;
                        this.twoData=obj.twoData;
                        this.threeData=obj.threeData;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeauty31SumData(){
                this.$post("beautymanager/getBeauty31SumData",{storeid:this.storeid,fromdate:this.fromdate,todate:this.todate}).then(res=>{
                    if(res.sucess){
                        if(res.object!=null){
                            this.beautySumData=res.object;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/beauty/beauty31sumdata.vue